import levenshtein from 'fast-levenshtein'

const MAX_ALLOWED_DISTANCE = 3

export default function (searchString, fields) {
  return searchString.split(' ')
    .reduce((carry, search) => carry || searchByString(search, fields), false)
}

export function searchByString (search, fields) {
  return fields.reduce((carry, field) => {
    if (!search || !field) return false
    let searchStr = search.toString().toLowerCase()
    let str = field.toString().toLowerCase()

    if (searchStr === '') return false

    return carry ||
      str.includes(searchStr) ||
      levenshtein.get(str, searchStr) <= MAX_ALLOWED_DISTANCE
  }, false)
}



// WEBPACK FOOTER //
// ./client/mixins/search.js